import React, { Component } from "react"
import { Row, Col, Card, CardBody, Button } from "reactstrap"
// Modal, ModalHeader, ModalBody, ModalFooter
import MetaTags from 'react-meta-tags'
import moment from 'moment'


// datatable related plugins
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationProvider, PaginationListStandalone,
  SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import SweetAlert from 'react-bootstrap-sweetalert';

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import "./datatables.scss"


import httprequester from '../../lib/httprequester'

class verifikasisertifikat extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      sizePerPage: 10,
      listSertifikat: [],
      alert: false,
      openmodal: false,
      // modal: false,
      message: '',
      urlimage: '',
      id: null
    }

  }

  getSertifikat = () => {
    let body = {
      "certificate_status": "W"
    }

    httprequester.postnobody('admin/list_moderating_certificate', body, {
      success: async function (response) {
        if (response.data.message == "success") {
          let data = []
          response.data.detailMessage.forEach(async (v, key) => {
            await data.push({
              certificate_id: v.certificate_id,
              certificate_issued: moment(v.certificate_issued).format('DD MMM YYYY'),
              certificate_name: v.certificate_name,
              certificate_skp: v.certificate_skp,
              certificate_status: v.certificate_status,
              certificate_url: v.certificate_url,
              created_at: v.created_at,
              str_id: v.str_id,
              str_no: v.str_no,
              updated_at: v.updated_at,
              user_id: v.user_id,
              user_name: v.user_name
            })
          })
          this.setState({
            listSertifikat: data
          })
        }
        // console.log(response)
      }.bind(this),
      error: function (err) {

      }.bind(this)

    })
  }

  handlecancel = () => {
    this.setState({
      alert: false
    })
  }

  approve = (id) => {
    // console.log('id',id)
    let body = {
      "certificate_id": id,
      "action": "Approve"
    }

    httprequester.postnobody('admin/moderating_certificate', body, {
      success: async function (response) {
        if (response.data.message == "success") {
          this.setState({
            message: response.data.detailMessage,
            alert: true
          })
          this.getSertifikat()
        }
        // console.log(response)
      }.bind(this),
      error: function (err) {

      }.bind(this)

    })
  }

  reject = (id) => {
    // console.log('id', this.state.id)
    let body = {
      "certificate_id": id,
      "action": "Reject"
    }

    httprequester.postnobody('admin/moderating_certificate', body, {
      success: async function (response) {
        if (response.data.message == "success") {
          this.setState({
            message: response.data.detailMessage,
            alert: true
          })
          this.getSertifikat()
        }
        // console.log(response)
      }.bind(this),
      error: function (err) {

      }.bind(this)

    })
  }

  Open = (url) => {
    this.setState({
      openmodal: true,
      modal: true,
      urlimage: url
    })
  }

  componentDidMount() {
    this.getSertifikat()
  }

  render() {

    const columns = [{
      dataField: 'certificate_url',
      text: 'Evidence',
      sort: true,
      formatter: (row) => {
        return <div>
          <img
            src={row}
            alt="sertifikat-img"
            title="sertifikat-img"
            className="avatar-md"
            onClick={() => window.open(row, "_blank")}
          // onClick={(e) => { this.Open(row) }}
          />
        </div>
      }
    }, {
      dataField: 'certificate_name',
      text: 'Nama Sertifikat',
      sort: true
    }, {
      dataField: 'certificate_skp',
      text: 'Jumlah SKP',
      sort: true
    }, {
      dataField: 'certificate_issued',
      text: 'Tanggal Sertifikat',
      sort: true
    }, {
      dataField: 'user_name',
      text: 'Username',
      sort: true
    }, {
      dataField: 'certificate_id',
      text: 'Action',
      sort: true,
      formatter: (row) => {
        // console.log('bener', row)
        return <div>
          <Button
            color="danger"
            className="btn-sm"
            onClick={(e) => { this.approve(row) }}
          >
            Approve
          </Button>
          &nbsp;
          <Button color="primary" className="btn-sm" onClick={(e) => this.reject(row)}>
            Reject
          </Button>
        </div>
      }
    }];

    const defaultSorted = [{
      dataField: 'certificate_name',
      order: 'asc'
    }];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: this.state.listSertifikat.length, // replace later with size(customers),
      custom: true,
    }

    // Custom Pagination Toggle
    const sizePerPageList = [
      { text: '5', value: 5 },
      { text: '10', value: 10 },
      { text: '15', value: 15 },
      { text: '20', value: 20 },
      { text: '25', value: 25 },
      { text: 'All', value: (this.state.listSertifikat).length }];




    const { SearchBar } = Search;

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Sertifikat | Ruang Ilmiah</title>
          </MetaTags>
          <div className="container-fluid">
            <Breadcrumbs title="User" breadcrumbItem="Verifikasi Sertifikat" />

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField='certificate_name'
                      columns={columns}
                      data={this.state.listSertifikat}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField='certificate_name'
                          columns={columns}
                          data={this.state.listSertifikat}
                          search
                        >
                          {toolkitProps => (
                            <React.Fragment>

                              <Row className="mb-2">
                                <Col md="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      keyField={"certificate_name"}
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />

                                  </div>
                                </Col>
                              </Row>

                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                  <div className="text-md-right ms-auto">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          )
                          }
                        </ToolkitProvider>
                      )
                      }</PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
          {this.state.alert ?
            <SweetAlert success title={this.state.message} onConfirm={this.handlecancel}>
            </SweetAlert> : ''
          }
          {/* {
            this.state.modal ? <Modal
              isOpen={this.state.openmodal}
            >
              <ModalHeader>
                Modal title
              </ModalHeader>
              <ModalBody>
                <img
                  src={this.state.urlimage}
                  alt="sertifikat-img"
                  title="sertifikat-img"
                />
              </ModalBody>
              <ModalFooter>
                <Button onClick={this.setState({ openmodal: false })}>
                  Cancel
                </Button>
              </ModalFooter>
            </Modal> : ''
          } */}
        </div>
      </React.Fragment>
    )
  }
}

export default verifikasisertifikat